/* global $:true */
import debug from "debug";
import plugin from '../../lib/plugin';

const ELEMENT_SELECTOR = '[data-click-tracking]';
const TRACK_ID_ATTR = 'data-click-tracking-trackid';
const HIT_ID_ATTR = 'data-click-tracking-hitid';
const HIT_QUERY_ATTR = 'data-click-tracking-hitquery';
const PLUGIN_NAME = 'clickTracking';
const MODULE_NAME = 'app.core/modules/click-tracking';
const log = debug(MODULE_NAME);

log('registerd');

class ClickTracking {

 constructor(element, options) {
		this.element = element;
		this.options = options;
		this.$element = $(element);
		this.hitId =this.$element.attr(HIT_ID_ATTR);
		this.query =this.$element.attr(HIT_QUERY_ATTR);
		this.trackId =this.$element.attr(TRACK_ID_ATTR);
		log('construct', element);

		this.watch();

	}

	sendClickTrackingData() {
		const url = `${this.options.url}?${this.options
            .endpointParam1}=${this.hitId}&${this.options
            .endpointParam2}=${this.query}&${this.options
            .endpointParam3}=${this.trackId}`;
		 $.ajax({
            url,
            method: 'get',
            success: result => {
            },
            error: e => {
                log('sendClickTrackingData', e);
            }
        }).done(() => {
            log('accepted', this.$element, url);
        });
	}

	watch () {
		var module = this;
		this.$element.on('click', function(e) { module.sendClickTrackingData();});
	}
}

ClickTracking.DEFAULTS = {
	url: $(`meta[name="site.clickTrackingApiEndpoint"]`).attr('content'),
	endpointParam1 : 'hitId',
	endpointParam2: 'query',
	endpointParam3: 'trackId'
};

plugin(PLUGIN_NAME, ClickTracking);

export function exec () {
  $(document).ready(() => {
	$(ELEMENT_SELECTOR)[PLUGIN_NAME]();
  });
}



// WEBPACK FOOTER //
// ./client/src/core/components/click-tracking/index.js